<template>
  <div class="live-info">
    <div class="top new-top blue-text center-flex">
      <div class="display-flex center-flex">
        <img src="@/assets/images/a-046_zhibo@2x.png" alt="" class="icon-zb">
        <span class="fs20 ml10 title-text">直播活动</span>
      </div>
      <div>
        <GsMore @click="moreDetail">查看更多</GsMore>
      </div>
    </div>
    <div class="hot-bottom-container" v-if="liveList && liveList.length > 0">
      <!-- 左箭头按钮 -->
      <button type="button" class="carousel-btn prev-btn" @click.stop="prevSlide" aria-label="上一组">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      
      <div class="hot-bottom" ref="viewport" :style="cardStep ? { '--live-card-w': cardStep + 'px' } : null">
        <div class="live-track" :style="trackStyle">
        <div 
          class="detail-box hand-cursor" 
          v-for="(item,i) in loopList" 
          :key="(item.id || item.title || 'live') + '-' + i"
          @click="onClick(item)"
        >
          <img :src="prodUrl+item.imageUrl" alt="" class="hand-cursor"/>
          <div class="detail-text">
            <div>
              <div class="mb5 fw700">
                <img src="@/assets/images/shijian-25 2@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
                <span class="blue-text time-text-style">{{item.state === 1 ? '直播倒计时' : (item.state === 2 ? '正在直播中' : '直播已结束')}}</span>
                <span v-if="item.state === 1" class="red time-text ml5">
                  <span v-if="item.deadline && item.deadline > 1">
                    {{ item.deadline }}天
                  </span>
                  <span v-else>
                    {{ computedTime(item.beginDate) }}
                  </span>
                </span>
                <span v-if="item.state === 3" class="red time-text ml5 gray">00:00:00</span>
              </div>
            </div>
            <div class="text-title ellipsis-one" :title="item.title">{{item.title}}</div>
            <div class="detail-content">
              <p class="ellipsis-one" :title="item.trainingInstructors">培训讲师: {{item.trainingInstructors}}</p>
              <p class="ellipsis-one" :title="item.lecturerUnit">讲师单位: {{item.lecturerUnit}}</p>
              <p class="ellipsis-one">课程分类: {{ transFormEnum(labelList, item.courseClassification) }}</p>
              <p class="ellipsis-one" :title="item.courseSource">课程来源: {{item.courseSource}}</p>
            </div>
          </div>
          <div v-if="item.stateName" class="iv-tips" :class="item.state === 1 ? 'jijiangzhibo' : (item.state === 2 ? 'zhibozhong' : 'zhibojieshu')">
            <img v-if="item.state === 1" src="@/assets/images/yuyue-2 2@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
            <img v-if="item.state === 2" src="@/assets/images/形状@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
            <img v-if="item.state === 3" src="@/assets/images/zhibohuifang@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
            {{item.stateName}}
          </div>
        </div>
        </div>
      </div>
      
      <!-- 右箭头按钮 -->
      <button type="button" class="carousel-btn next-btn" @click.stop="nextSlide" aria-label="下一组">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div v-else>
      <NoData />
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData/index.vue'
import {enumType} from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import {
  getLiveList
} from "@/api/api";
import { P } from '@/router/paths'

export default {
  name: 'LiveInfo',
  components: { NoData },
  data() {
    return {
      liveList: [
        {
          title: '黑悟空神话，又飒好者恶事俄文俄文',
          trainingInstructors: '李三',
          lecturerUnit: '上海交通大学泰安经济与管理学院',
          courseSource: '中心处本社',
          deadline: '25:03:26',
          state: 1,
          stateName: '正在直播'
        },
        {
          title: '黑悟空神话，又飒好者恶事俄文俄文',
          trainingInstructors: '李三',
          lecturerUnit: '上海交通大学泰安经济与管理学院',
          courseSource: '中心处本社',
          deadline: '25:03:26',
          state: 3,
          stateName: '正在直播'
        },
        {
          title: '黑悟空神话，又飒好者恶事俄文俄文',
          trainingInstructors: '李三',
          lecturerUnit: '上海交通大学泰安经济与管理学院',
          courseSource: '中心处本社',
          deadline: '25:03:26',
          state: 2,
          stateName: '正在直播'
        },
        {
          title: '黑悟空神话，又飒好者恶事俄文俄文',
          trainingInstructors: '李三',
          lecturerUnit: '上海交通大学泰安经济与管理学院',
          courseSource: '中心处本社',
          deadline: '25:03:26',
          state: 2,
          stateName: '正在直播'
        },
        {
          title: '黑悟空神话，又飒好者恶事俄文俄文',
          trainingInstructors: '李三',
          lecturerUnit: '上海交通大学泰安经济与管理学院',
          courseSource: '中心处本社',
          deadline: '25:03:26',
          state: 3,
          stateName: '正在直播'
        }
        
      ],
      fileTimer: null,
      countdownTimer: null, // 新增：倒计时定时器
      prodUrl: "https://shujuzichan.com/xwzx",
      labelList: [],
      currentIndex: 0,
      trackIndex: 0,
      cardStep: 0,
      slideAnim: true,
      animating: false,
      itemsPerPage: 4,
      autoPlayInterval: null
    };
  },
  computed: {
    visibleItems() {
      const start = this.currentIndex;
      const end = start + this.itemsPerPage;
      if (end > this.liveList.length) {
        return [
          ...this.liveList.slice(start),
          ...this.liveList.slice(0, end - this.liveList.length)
        ];
      }
      return this.liveList.slice(start, end);
    },
    loopList() {
      const list = this.liveList || []
      if (!list.length) return []
      return list.concat(list.slice(0, this.itemsPerPage))
    },
    trackStyle() {
      return {
        transform: `translate3d(${-this.trackIndex * this.cardStep}px, 0, 0)`,
        transition: this.slideAnim ? 'transform 0.45s cubic-bezier(0.22, 0.61, 0.36, 1)' : 'none'
      }
    },
    transFormEnum() {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  created() {
    this.getLiveList();
    this.getData('sys_live_course_classification');
  },
  mounted() {
    this.$nextTick(() => {
      this.measureCard();
      this.startAutoPlay();
    });
    this.startCountdownTimer();
    this._onLiveResize = () => this.measureCard();
    window.addEventListener('resize', this._onLiveResize);
  },
  beforeUnmount() {
    this.stopAutoPlay();
    clearInterval(this.fileTimer);
    clearInterval(this.countdownTimer);
    clearTimeout(this._slideTimer);
    window.removeEventListener('resize', this._onLiveResize);
  },
  beforeDestroy() {
    this.stopAutoPlay();
    clearInterval(this.fileTimer);
    clearInterval(this.countdownTimer);
    clearTimeout(this._slideTimer);
    window.removeEventListener('resize', this._onLiveResize);
  },
  methods: {
    // 新增：启动倒计时定时器
    startCountdownTimer() {
      this.countdownTimer = setInterval(() => {
        // 强制组件重新渲染，更新倒计时显示
        this.$forceUpdate();
      }, 5000); // 每秒更新一次
    },
    computedTime(beginDate) {
      if (!beginDate) return '--:--:--';
      
      // 将开始时间转换为Date对象
      const targetTime = new Date(beginDate).getTime();
      const now = new Date().getTime();
      
      // 计算时间差（毫秒）
      const diff = targetTime - now;
      
      if (diff <= 0) {
        // 如果时间已过，显示00:00:00
        return '00:00:00';
      }
      
      // 计算时、分、秒
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      // 格式化为两位数
      const formatHours = hours.toString().padStart(2, '0');
      const formatMinutes = minutes.toString().padStart(2, '0');
      const formatSeconds = seconds.toString().padStart(2, '0');
      
      return `${formatHours}:${formatMinutes}:${formatSeconds}`;
    },
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_live_course_classification') {
            this.labelList = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    getLiveList() {
      var formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 10;
      getLiveList(formData).then((response) => {
        this.liveList = response.rows || [];
        this.currentIndex = 0;
        this.trackIndex = 0;
        this.slideAnim = false;
        this.$nextTick(() => {
          this.measureCard();
          this.slideAnim = true;
          this.startAutoPlay();
        });
      });
    },
    onClick(item) {
      window.open(item.url, "_blank");
    },
    moreDetail() {
      this.$router.push(P.live)
    },
    fileMarquee() {
      this.fileTimer = null
    },
    startAutoPlay() {
      this.stopAutoPlay();
      if (!this.liveList.length || window.innerWidth <= 960) return
      this.autoPlayInterval = setInterval(() => {
        this.stepSlide(1);
      }, 5000);
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    measureCard() {
      const el = this.$refs.viewport
      if (!el) return
      const per = window.innerWidth <= 960 ? 1 : this.itemsPerPage
      this.cardStep = Math.max(0, Math.round(el.clientWidth / per))
    },
    afterSlide(cb) {
      clearTimeout(this._slideTimer)
      this._slideTimer = setTimeout(cb, 460)
    },
    stepSlide(dir) {
      const len = this.liveList.length
      if (!len || this.animating || window.innerWidth <= 960) return
      if (!this.cardStep) this.measureCard()
      this.animating = true
      if (dir > 0) {
        this.slideAnim = true
        this.trackIndex += 1
        this.currentIndex = (this.currentIndex + 1) % len
        this.afterSlide(() => {
          if (this.trackIndex >= len) {
            this.slideAnim = false
            this.trackIndex = 0
          }
          this.animating = false
        })
        return
      }
      if (this.trackIndex === 0) {
        this.slideAnim = false
        this.trackIndex = len
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.slideAnim = true
            this.trackIndex -= 1
            this.currentIndex = (this.currentIndex - 1 + len) % len
            this.afterSlide(() => { this.animating = false })
          })
        })
        return
      }
      this.slideAnim = true
      this.trackIndex -= 1
      this.currentIndex = (this.currentIndex - 1 + len) % len
      this.afterSlide(() => { this.animating = false })
    },
    prevSlide() {
      this.stopAutoPlay();
      this.stepSlide(-1);
      this.startAutoPlay();
    },
    nextSlide() {
      this.stopAutoPlay();
      this.stepSlide(1);
      this.startAutoPlay();
    },
    goToSlide(index) {
      this.stopAutoPlay();
      this.currentIndex = index;
      this.trackIndex = index;
      this.startAutoPlay();
    }
  }
};
</script>

<style scoped>
.icon-zb {
  width: 60px;
  height: 42px;
}
.live-info {
  padding-top: 8px;
}
.top {
  font-weight: 700;
  margin-bottom: 15px;
}
.hot-center-left img {
  width: 100%;
  height: 100%;
}
.more:hover {
  color:red;
}
.time-text {
  height: 20px;
  font-family: DINCondensed, DINCondensed;
  font-weight: bold;
  font-size: 20px;
  color: #0165FF;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.gray {
  height: 20px;
  font-family: DINCondensed, DINCondensed;
  font-weight: bold;
  font-size: 20px;
  color: #7E8288;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.time-text-style {
  height: 20px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.icon-tips {
  width: 12px !important;
  height: 12px !important;
}
/* 轮播容器样式 */
.hot-bottom-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 12px;
}

.hot-bottom {
  width: 100%;
  overflow: hidden;
  padding-top: 12px;
  padding-bottom: 10px;
}

.live-track {
  display: flex;
  will-change: transform;
}

/* 轮播按钮样式 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  color: #0165FF;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.carousel-btn:hover {
  background: #0165FF;
  color: white;
}

.prev-btn {
  left: -20px;
}

.next-btn {
  right: 5px;
}

.detail-box {
  flex: 0 0 var(--live-card-w, 25%);
  width: var(--live-card-w, 25%);
  min-width: 0;
  box-sizing: border-box;
  padding-right: 10px;
  margin-right: 0;
  position: relative;
  overflow: hidden;
  transition: transform 0.28s ease;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.detail-box img {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 118px;
  flex: 0 0 118px;
  object-fit: cover;
  object-position: center;
  border-radius: 15px 0 0 0;
}

.detail-text {
  position: relative;
  top: auto;
  margin: -28px 10px 0;
  height: auto;
  min-height: 148px;
  background: #FFFFFF;
  border-radius: 8px;
  width: auto;
  max-width: calc(100% - 20px);
  padding: 12px 14px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(17, 24, 36, 0.08);
}

.text-title {
  width: 100%;
  height: 32px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 20px;
  color: #111824;
  line-height: 32px;
  text-align: left;
  font-style: normal;
}

.detail-content{
  /* height: 80px; */
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #111824;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.iv-tips{
  position: absolute;
  top: 0px;
  left: 0;
  font-weight: 600;
  width: auto;
  min-width: 0;
  max-width: calc(100% - 16px);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  white-space: nowrap;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 12px;
  color: #FFFFFF;
  padding: 4px 8px;
  border-radius: 15px 0;
  background: #54637A ;
}

.jijiangzhibo {
  background-color: #5FDC00;
}

.zhibozhong {
  /* background: rgb(236, 222, 75);
  color: #ff0000; */
  background-color: #0165FF;
}

.new-top {
  /* margin-left: 10px; */
  background-image: url('@/assets/images/矩形@2x.png');
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

/* 响应式调整 */
/* @media (max-width: 1200px) {
  .detail-box {
    flex: 0 0 calc(33.333% - 10px);
  }
} */

@media (max-width: 960px) {
  .title-text {
    font-size: 18px;
  }
  .icon-zb {
    width: 42px;
    height: 30px;
  }
  .hot-bottom {
    overflow: visible;
  }
  .live-track {
    flex-direction: column;
    transform: none !important;
  }
  .detail-box {
    flex: none;
    width: 100%;
    padding-right: 0;
    margin-right: 0;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 10px rgba(17, 24, 36, 0.08);
  }
  .detail-box + .detail-box {
    display: none;
  }
  .detail-box > img {
    height: 168px;
    width: 100%;
    object-fit: cover;
    border-radius: 0;
  }
  .detail-text {
    position: relative;
    top: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0;
    padding: 12px 14px 14px;
    border-radius: 0;
    box-sizing: border-box;
  }
  .text-title {
    height: auto;
    font-size: 16px;
    line-height: 22px;
    white-space: normal;
    margin-bottom: 6px;
  }
  .iv-tips {
    top: 10px;
    left: 10px;
    width: auto;
    min-width: 72px;
    height: auto;
    padding: 5px 10px;
    border-radius: 12px;
  }
  .carousel-btn {
    display: none;
  }
}
.detail-box:hover {
  transform: translateY(-6px);
  box-shadow: none;
}
</style>